import * as React from "react";
function SvgArrowsSpin(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        d="M23.15 29.17a15 15 0 00-2.9-27.53M8.85 2.83a15 15 0 002.9 27.53"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
      />
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
        d="M31 30h-8v-8M1 2h8v8"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgArrowsSpin);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
